import store from "../store/store";

const state = store.getState();
export const lang = state.lang;
export const currency = state.currency;
export const translations = state.translations;

export const dispPrice = (val) => {
  val =
    currency.currency === "KWD" || currency.currency === "BHD"
      ? (currency.price * val).toFixed(3)
      : (currency.price * val).toFixed(2);
  return `${currency.currency} ${val}`;
};

export const getPrice = (val) => {
  val = (currency.price * val).toFixed(3);
  return val;
};

export const getWord = (val) => {
  const value = val.trim().toLowerCase();
  const word = translations[lang][value] ? translations[lang][value] : val;
  return word;
};
